module.exports = __webpack_public_path__ + "img/setting_information.31962b1b.svg";